export default "__VITE_ASSET__DASq1qku__"